"use client";

import { Dispatch, SetStateAction, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import EventCard, { EventCardSkeleton, NoEvents } from "./EventCard";
import ViewAllVideos from "./ViewAllVideos";
import EventFilter, { FilterType } from "./EventFilter";
import { useGetAllEventsQuery } from "@/redux/feature/calender/calenderApi";
import Modal from "@/components/ui/Modal";
import SelectModal from "@/pages/ProductStructure/components/SelectModal/SelectModal";

type ViewAllEventsProps = {
  productId: string;
  setIsSelectModalOpen: Dispatch<SetStateAction<boolean>>;
};

const ViewAllEvents = ({
  productId,
  setIsSelectModalOpen,
}: ViewAllEventsProps) => {
  const [isViewEventDetails, setIsViewEventDetails] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [filter, setFilter] = useState<FilterType>("all-upcoming");

  const { data, isLoading, isError } = useGetAllEventsQuery({
    filter,
    productId,
  });

  const handleOpenEvent = (event: any) => {
    setSelectedEvent(event);
    setIsViewEventDetails(true);
  };

  const handleBack = () => {
    setIsViewEventDetails(false);
    setSelectedEvent(null);
  };

  return (
    <div className="relative">
      <AnimatePresence mode="wait">
        {isViewEventDetails && selectedEvent ? (
          <motion.section
            key="videos"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.3 }}
          >
            <ViewAllVideos event={selectedEvent} onBack={handleBack} />
          </motion.section>
        ) : (
          <motion.section
            key="events"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            transition={{ duration: 0.3 }}
          >
            <h3 className="text-2xl font-medium text-center mb-6">
              Event Calendar 🗓
            </h3>

            <EventFilter selected={filter} onChange={setFilter} />

            {/* Events Section */}
            <div className="mt-6">
              {isLoading && (
                <>
                  <EventCardSkeleton />
                  <EventCardSkeleton />
                  <EventCardSkeleton />
                </>
              )}
              {isError && (
                <p className="text-center text-red-500">
                  Failed to fetch events. Try again.
                </p>
              )}
              {!isLoading && data?.events?.length === 0 && <NoEvents />}
              {!isLoading &&
                data?.events?.map((event: any) => (
                  <div
                    onClick={() => handleOpenEvent(event)}
                    className="cursor-pointer"
                  >
                    <EventCard
                      key={event.id}
                      event={event}
                      setIsSelectModalOpen={setIsSelectModalOpen}
                    />
                  </div>
                ))}
            </div>
          </motion.section>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ViewAllEvents;
